import { render } from "./barLoader.vue?vue&type=template&id=f19d24d0&scoped=true"
import script from "./barLoader.vue?vue&type=script&lang=js"
export * from "./barLoader.vue?vue&type=script&lang=js"

import "./barLoader.vue?vue&type=style&index=0&id=f19d24d0&lang=scss&scoped=true"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f19d24d0"]])

export default __exports__